import { render } from "./RegionAnalyticsView.vue?vue&type=template&id=62b32e78"
import script from "./RegionAnalyticsView.vue?vue&type=script&lang=js"
export * from "./RegionAnalyticsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__